import { ActionsBar, Button, Column } from '@ydistri/ds';
import React, { useCallback } from 'react';
import { useTemplateOrCalculation } from '../../../../../../../../hooks/useTemplateOrCalculation';
import { useRunCalculationImportMutation } from '../../../apiCalculationRedistributionImport';
import { ReduxState, useAppDispatch } from '../../../../../../../../store';
import { useSelector } from 'react-redux';
import { setImportStep } from '../../../../../../../Calculations/calculationsSlice';
import { ProcessingStep } from '../../../redistributionImportTypes';
import useResetImport from '../../common/useResetImport';
import { Alert } from 'antd';
import { getRequestErrorMessage } from '../../../../../../../../lib/utils/getRequestErrorMessage';

interface RedistributionImportItemsActionsProps {
  canFinalize: boolean;
}

const RedistributionImportItemsActions: React.FC<RedistributionImportItemsActionsProps> = ({
  canFinalize,
}) => {
  const calculation = useTemplateOrCalculation();
  const verificationTimeStamp = useSelector(
    (state: ReduxState) => state.calculations.redistributionImport.verificationTimeStamp,
  );
  const dispatch = useAppDispatch();
  const resetImport = useResetImport();

  const [runCalculationImport, { isLoading, error }] = useRunCalculationImportMutation();

  const finalizeClickHandler = useCallback(() => {
    runCalculationImport({
      calculationId: calculation.id,
      verificationTimeStamp,
    })
      .unwrap()
      .then(() => {
        dispatch(
          setImportStep({
            stepIndex: ProcessingStep.FINALIZED,
            stepRunning: true,
          }),
        );
      })
      .catch(() => {
        // The mutation error stays visible on the validation screen.
      });
  }, [calculation.id, dispatch, runCalculationImport, verificationTimeStamp]);

  return (
    <Column $gap="8px">
      {error && (
        <Alert
          type="error"
          showIcon
          message="Import could not be confirmed"
          description={getRequestErrorMessage(error, 'Please try again.')}
        />
      )}
      <ActionsBar>
        <Button
          onClick={finalizeClickHandler}
          disabled={!canFinalize || isLoading}
          $colorVariant="primary"
        >
          Finalize import
        </Button>
        <Button onClick={resetImport} disabled={isLoading} $colorVariant="ghostPrimary">
          Cancel
        </Button>
      </ActionsBar>
    </Column>
  );
};

export default RedistributionImportItemsActions;
